var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C21.7322 0 28 6.2678 28 14C28 21.7322 21.7322 28 14 28C6.2678 28 0 21.7322 0 14C0 6.2678 6.2678 0 14 0ZM18.949 8.9334L12.019 15.8634L9.051 12.894C8.92102 12.7639 8.76669 12.6607 8.59682 12.5903C8.42696 12.5199 8.24488 12.4836 8.061 12.4835C7.68962 12.4834 7.3334 12.6308 7.0707 12.8933C6.808 13.1558 6.66035 13.5119 6.66022 13.8833C6.66009 14.2547 6.80749 14.6109 7.07 14.8736L10.9312 18.7348C11.0742 18.8779 11.244 18.9914 11.4309 19.0688C11.6178 19.1463 11.8181 19.1861 12.0204 19.1861C12.2227 19.1861 12.423 19.1463 12.6099 19.0688C12.7968 18.9914 12.9666 18.8779 13.1096 18.7348L20.93 10.9144C21.1927 10.6517 21.3403 10.2954 21.3403 9.9239C21.3403 9.55239 21.1927 9.1961 20.93 8.9334C20.6673 8.6707 20.311 8.52312 19.9395 8.52312C19.568 8.52312 19.2117 8.6707 18.949 8.9334Z",
    fill: "#4EBD7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8b981ecfba230377a31e48f6332927c9.svg";
export { ForwardRef as ReactComponent };